// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__1KGuf"};